import React, { useEffect, useRef, useState } from "react";
import { MinusCircle, PlusCircle } from "phosphor-react";
import {} from "effector";
import {
  setSelectedMinutes,
  setFinalPrice,
} from "../../../../../../stores/VacuumStore/VacuumStore";
import { roundToTwo } from "../../../../../../utils/functions";
import {
  PickTimeContainer,
  TimeSelection,
  MinutesField,
  JustFlex,
  TotalValue,
} from "./PickTimeStyles";
import { VacuumOption } from "../../../../../../types/vacuum.types";

interface Props {
  selectedMinutes: number;
  selectedVacuum: VacuumOption | undefined;
  finalPrice: number;
}

const PickTime: React.FC<Props> = ({
  selectedMinutes,
  selectedVacuum,
  finalPrice,
}: Props) => {
  const [minutes, setMinutes] = useState(selectedMinutes);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setSelectedMinutes(selectedMinutes);

    const vacPrice = selectedVacuum?.pricePerMinute ?? 0;
    const totalPrice = selectedMinutes * vacPrice;

    setFinalPrice(roundToTwo(totalPrice));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMinutes]);

  const startHolding = (direction: number) => {
    // Clique inicial
    setMinutes((prev) => {
      let updated = prev + direction;

      // if (updated <= 5) updated = 5;
      if (updated <= 1) updated = 1;
      if (updated >= 60) updated = 60;

      setSelectedMinutes(updated);
      return updated;
    });

    intervalRef.current = setInterval(() => {
      setMinutes((prev) => {
        const updated = prev + direction;
        setSelectedMinutes(updated);
        return updated;
      });
    }, 200);
  };

  const stopHolding = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const renderContent = () => {
    return (
      <TimeSelection>
        <MinusCircle
          size={"small"}
          onMouseDown={() => startHolding(-1)}
          onTouchEndCapture={(event) => event.preventDefault()}
          onMouseUp={stopHolding}
          onMouseLeave={stopHolding}
          onTouchStart={() => startHolding(-1)}
          onTouchEnd={stopHolding}
        />
        <JustFlex>
          <MinutesField>{minutes}</MinutesField>
          <p>minutos</p>
        </JustFlex>
        <PlusCircle
          size={"small"}
          onMouseDown={() => startHolding(1)}
          onTouchEndCapture={(event) => event.preventDefault()}
          onMouseUp={stopHolding}
          onMouseLeave={stopHolding}
          onTouchStart={() => startHolding(1)}
          onTouchEnd={stopHolding}
        />
      </TimeSelection>
    );
  };

  const renderPrice = () => (
    <TotalValue>
      <p>Total</p>

      <p>R$ {finalPrice.toFixed(2)}</p>
    </TotalValue>
  );

  return (
    <PickTimeContainer>
      {renderContent()}
      {renderPrice()}
    </PickTimeContainer>
  );
};

export default PickTime;
